interface UserProfile {
    company: string,
    id: string,
    image: string,
    name: string,
    position: string
}

interface User {
    firstname: string,
    lastname: string,
    position: string,
    project: string
}

export interface Project {
    name: string
}

export class UserModel implements User {
    firstname: string;
    lastname: string;
    position: string;
    project: string;

    constructor(data: User) {
        this.firstname = data.firstname
        this.lastname = data.lastname
        this.position = data.position
        this.project = data.project
    }
}

export class UserProfileModel implements UserProfile {
    company: string;
    id: string;
    image: string;
    name: string;
    position: string;

    constructor(data: UserProfile) {
        this.company = data.company
        this.id = data.id
        this.image = data.image
        this.name = data.name
        this.position = data.position
    }
}

export class ProjectModel implements Project {
    name: string;

    constructor(data: Project) {
        this.name = data.name
    }
}

enum Position {
    Plumber = 'Rørlegger',
    Leder = 'Prosjektleder'
}

if(!Position){
console.log(Position)
}
